import React, { useState, useRef, useEffect } from "react";
import { Card, Table, Dropdown, Form, InputGroup } from "react-bootstrap";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  Typography,
  Avatar,
  Grid,
  IconButton,
  OutlinedInput,
} from "@mui/material";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import { Eye, Pencil, Trash, Calendar } from "react-bootstrap-icons";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { FaEdit } from "react-icons/fa";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FiChevronDown } from "react-icons/fi";
const CompaniesList = () => {
  const [plan, setPlan] = useState("Select Plan");
  const [status, setStatus] = useState("Select Status");
  const [sort, setSort] = useState("Sort By : Last 7 Days");

  // date range picker state
  const [dateRangeLabel, setDateRangeLabel] = useState("03/31/2026 - 04/21/2026");
  const [customStart, setCustomStart] = useState("");
  const [customEnd, setCustomEnd] = useState("");

  const [showModal, setShowModal] = useState(false);
  // list data and selection
  const initialCompanies = [
    {
      name: "BrightWave Innovations",
      email: "[email protected]",
      url: "bwi.example.com",
      plan: "Advanced (Monthly)",
      date: "12 Sep 2024",
      status: "Active",
      img: "/assets/img/company/company-01.svg",
    },
    {
      name: "Stellar Dynamics",
      email: "[email protected]",
      url: "sd.example.com",
      plan: "Basic (Yearly)",
      date: "24 Oct 2024",
      status: "Active",
      img: "/assets/img/company/company-02.svg",
    },
    {
      name: "Quantum Nexus",
      email: "[email protected]",
      url: "qn.example.com",
      plan: "Advanced (Monthly)",
      date: "18 Feb 2024",
      status: "Active",
      img: "/assets/img/company/company-03.svg",
    },
    {
      name: "EcoVision Enterprises",
      email: "[email protected]",
      url: "eve.example.com",
      plan: "Advanced (Monthly)",
      date: "17 Oct 2024",
      status: "Active",
      img: "/assets/img/company/company-04.svg",
    },
    {
      name: "Aurora Technologies",
      email: "[email protected]",
      url: "at.example.com",
      plan: "Enterprise (Monthly)",
      date: "20 Jul 2024",
      status: "Active",
      img: "/assets/img/company/company-05.svg",
    },
  ];
  const selectedCompanydata = {
    img: "your-logo-url",
    name: "BrightWave Innovations",
    email: "[email protected]",
    url: "bwi.example.com",
    phoneNumber: "(163) 2459 315",
    website: "www.example.com",
    currency: "United States Dollar (USD)",
    language: "English",
    address: "3705 Lynn Avenue, Phelps, WI 54554",
    planName: "Advanced",
    planType: "Monthly",
    price: "200",
    registerDate: "12 Sep 2024",
    expiringOn: "11 Oct 2024",
    status: "Active",
  };
  const [companies, setCompanies] = useState(initialCompanies);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [showView, setShowView] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  // search & pagination controls
  const [searchQuery, setSearchQuery] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const fileInputRef = useRef();
  const [editData, setEditData] = useState({});

  // helper to format yyyy-mm-dd -> mm/dd/yyyy
  const formatInputDate = (iso) => {
    if (!iso) return "";
    const [y, m, d] = iso.split("-");
    return `${m}/${d}/${y}`;
  };

  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  const daysAgo = (n) => {
    const d = new Date(today);
    d.setDate(d.getDate() - n);
    return d;
  };

  const formatDateObj = (d) => {
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  };

  const getRangeLabel = (label) => {
    switch (label) {
      case "Today":
        return formatDateObj(today);
      case "Yesterday":
        return formatDateObj(yesterday);
      case "Last 7 Days":
        return `${formatDateObj(daysAgo(6))} - ${formatDateObj(today)}`;
      case "Last 30 Days":
        return `${formatDateObj(daysAgo(29))} - ${formatDateObj(today)}`;
      case "This Year":
        return `01/01/${today.getFullYear()} - ${formatDateObj(today)}`;
      case "Next Year":
        return `01/01/${today.getFullYear() + 1} - 12/31/${today.getFullYear() + 1}`;
      default:
        return label;
    }
  };



  const updateCustomStart = (val) => {
    setCustomStart(val);
    if (customEnd) {
      setDateRangeLabel(
        `${formatInputDate(val)} - ${formatInputDate(customEnd)}`,
      );
    }
  };

  const updateCustomEnd = (val) => {
    setCustomEnd(val);
    if (customStart) {
      setDateRangeLabel(
        `${formatInputDate(customStart)} - ${formatInputDate(val)}`,
      );
    }
  };

  // Modal handlers
  const handleViewClick = (company) => {
    setSelectedCompany(company);
    setShowView(true);
  };

  const handleEditClick = (company) => {
    setSelectedCompany(company);
    setEditData(company);
    setShowEdit(true);
  };

  const handleDeleteClick = (company) => {
    setSelectedCompany(company);
    setShowDelete(true);
  };

  const handleConfirmDelete = () => {
    if (selectedCompany) {
      setCompanies(companies.filter((c) => c.name !== selectedCompany.name));
    }
    setShowDelete(false);
    setSelectedCompany(null);
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setEditData({ ...editData, img: event.target.result });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleEditChange = (field, value) => {
    setEditData({ ...editData, [field]: value });
  };

  const handleSaveEdit = () => {
    setCompanies(
      companies.map((c) => (c.name === selectedCompany.name ? editData : c)),
    );
    setShowEdit(false);
    setSelectedCompany(null);
  };

  const [image, setImage] = useState("");
  // const fileInputRef = useRef();

  useEffect(() => {
    const savedImage = localStorage.getItem("companyImage");
    if (savedImage) setImage(savedImage);
  }, []);

  const handleUploadClick = () => fileInputRef.current.click();

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    if (file.size > 4 * 1024 * 1024) {
      alert("Image must be below 4MB");
      return;
    }

    const reader = new FileReader();

    reader.onloadend = () => {
      setImage(reader.result);
      localStorage.setItem("companyImage", reader.result);
    };

    reader.readAsDataURL(file);
  };



  // Update label when custom range selected
  useEffect(() => {
    if (customStart && customEnd) {
      setDateRangeLabel(
        `${formatDate(customStart)} - ${formatDate(customEnd)}`
      );
    }
  }, [customStart, customEnd]);

const handleRangeSelect = (range) => {
  const today = new Date();
  let start = new Date();
  let end = new Date();

  switch (range) {
    case "Today":
      start = end = today;
      break;

    case "Yesterday":
      start = end = new Date(today.setDate(today.getDate() - 1));
      break;

    case "Last 7 Days":
      start = new Date();
      start.setDate(today.getDate() - 6);
      end = new Date();
      break;

    case "Last 30 Days":
      start = new Date();
      start.setDate(today.getDate() - 29);
      end = new Date();
      break;

    case "This Month":
      start = new Date(today.getFullYear(), today.getMonth(), 1);
      end = new Date();
      break;

    case "This Year":
      start = new Date(today.getFullYear(), 0, 1);
      end = new Date();
      break;

    case "Custom Range":
      setDateRangeLabel("Custom Range");
      return;

    default:
      return;
  }

  setCustomStart(start.toISOString().split("T")[0]);
  setCustomEnd(end.toISOString().split("T")[0]);

  setDateRangeLabel(
    `${formatDate(start)} - ${formatDate(end)}`
  );
};
const formatDate = (date) => {
  const d = new Date(date);
  return `${String(d.getMonth() + 1).padStart(2, "0")}/${String(
    d.getDate()
  ).padStart(2, "0")}/${d.getFullYear()}`;
};
  return (
    <Card className="shadow-sm     companies-list  border-0 mt-1">
      <Card.Header className="bg-white d-flex justify-content-between flex-wrap align-items-center">
        <h5 className="mb-0">Companies List</h5>

   <div className="d-flex flex-wrap gap-3 align-items-center">

      {/* DATE RANGE */}
      <Dropdown>
        <Dropdown.Toggle
          as="div"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
            padding: "8px 12px",
            minWidth: "200px",
            background: "#fff",
            cursor: "pointer",
            fontSize: "14px",
            color: "#111827",
          }}
        >
          <Calendar size={16} color="#6b7280" />

          <span>
            {dateRangeLabel === "Custom Range" && customStart && customEnd
              ? `${formatDate(customStart)} - ${formatDate(customEnd)}`
              : dateRangeLabel}
          </span>

          <FiChevronDown
            size={16}
            style={{ marginLeft: "auto", color: "#6b7280" }}
          />
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {[
            "Today",
            "Yesterday",
            "Last 7 Days",
            "Last 30 Days",
            "This Month",
            "This Year",
            "Custom Range",
          ].map((r) => (
            <Dropdown.Item
              key={r}
              onClick={() => handleRangeSelect(r)}
              style={{
                background: dateRangeLabel === r ? "#f26522" : "",
                color: dateRangeLabel === r ? "#fff" : "",
              }}
            >
              {r}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>

      {/* CUSTOM DATE INPUT */}
      {dateRangeLabel === "Custom Range" && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          <input
            type="date"
            value={customStart}
            onChange={(e) => setCustomStart(e.target.value)}
            style={{
              border: "none",
              padding: "8px",
              outline: "none",
            }}
          />

          <span style={{ padding: "0 6px", color: "#6b7280" }}>-</span>

          <input
            type="date"
            value={customEnd}
            onChange={(e) => setCustomEnd(e.target.value)}
            style={{
              border: "none",
              padding: "8px",
              outline: "none",
            }}
          />
        </div>
      )}

      {/* PLAN */}
      <Dropdown>
        <Dropdown.Toggle
          as="div"
          style={{
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
            padding: "8px 12px",
            minWidth: "150px",
            background: "#fff",
            cursor: "pointer",
            fontSize: "14px",
          }}
        >
          {plan}
          <FiChevronDown
            size={14}
            style={{ float: "right", color: "#6b7280" }}
          />
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {["Select Plan", "Advanced", "Basic", "Enterprise"].map((p) => (
            <Dropdown.Item
              key={p}
              onClick={() => setPlan(p)}
              style={{
                background: plan === p ? "#f26522" : "",
                color: plan === p ? "#fff" : "",
              }}
            >
              {p}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>

      {/* STATUS */}
      <Dropdown>
        <Dropdown.Toggle
          as="div"
          style={{
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
            padding: "8px 12px",
            minWidth: "140px",
            background: "#fff",
            cursor: "pointer",
            fontSize: "14px",
          }}
        >
          {status}
          <FiChevronDown
            size={14}
            style={{ float: "right", color: "#6b7280" }}
          />
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {["Select Status", "Active", "Inactive"].map((s) => (
            <Dropdown.Item
              key={s}
              onClick={() => setStatus(s)}
              style={{
                background: status === s ? "#f26522" : "",
                color: status === s ? "#fff" : "",
              }}
            >
              {s}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>

      {/* SORT */}
      <Dropdown>
        <Dropdown.Toggle
          as="div"
          style={{
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
            padding: "8px 12px",
            minWidth: "190px",
            background: "#fff",
            cursor: "pointer",
            fontSize: "14px",
          }}
        >
          Sort By : {sort}
          <FiChevronDown
            size={14}
            style={{ float: "right", color: "#6b7280" }}
          />
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {[
            "Recently Added",
            "Ascending",
            "Descending",
            "Last 7 Days",
            "Last Month",
          ].map((s) => (
            <Dropdown.Item
              key={s}
              onClick={() => setSort(s)}
              style={{
                background: sort === s ? "#f26522" : "",
                color: sort === s ? "#fff" : "",
              }}
            >
              {s}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>

    </div>
      </Card.Header>
      <Card.Footer className="bg-white border-top d-flex justify-content-between align-items-center px-3 py-3">
        <div className="d-flex align-items-center gap-2">
          <span style={{ fontSize: "14px", color: "#374151", fontWeight: 500 }}>
            Row Per Page
          </span>
          <Dropdown>
            <Dropdown.Toggle
              variant="light"
              className="shadow-sm border"
              style={{ minWidth: "60px", height: "36px", fontSize: "14px" }}
            >
              {rowsPerPage}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => setRowsPerPage(5)}>5</Dropdown.Item>
              <Dropdown.Item onClick={() => setRowsPerPage(10)}>
                10
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setRowsPerPage(15)}>
                15
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setRowsPerPage(20)}>
                20
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setRowsPerPage(50)}>
                50
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <span
            style={{ fontSize: "13px", color: "#6b7280", marginLeft: "8px" }}
          >
            Entries
          </span>
        </div>

        <div style={{ width: "250px" }}>
          <Form.Control
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{
              borderRadius: "6px",
              border: "1px solid #d1d5db",
              padding: "8px 12px",
              fontSize: "14px",
            }}
          />
        </div>
      </Card.Footer>

      <Card.Body className="p-0">
        <div className="table-responsive">
          <Table hover className="align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th>
                  <Form.Check />
                </th>
                <th>Company Name</th>
                <th>Email</th>
                <th>Account URL</th>
                <th>Plan</th>
                <th>Created Date</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {companies.map((company, index) => (
                <tr key={index}>
                  <td>
                    <Form.Check />
                  </td>

                  <td>
                    <div className="d-flex align-items-center">
                      <img
                        src={company.img}
                        alt=""
                        style={{
                          width: 40,
                          height: 40,
                          borderRadius: "50%",
                          border: "1px solid #eee",
                        }}
                      />

                      <div className="ms-2 fw-semibold">{company.name}</div>
                    </div>
                  </td>

                  <td>{company.email}</td>

                  <td>{company.url}</td>

                  <td>
                    <div className="d-flex justify-content-between align-items-center">
                      <span>{company.plan}</span>

                      <Button
                        size="sm"
                        style={{
                          background: "#a855f7",
                          border: "none",
                          fontSize: "11px",
                        }}
                      >
                        Upgrade
                      </Button>
                    </div>
                  </td>

                  <td>{company.date}</td>

                  <td>
                    {company.status === "Active" ? (
                      <span className="badge bg-success">● Active</span>
                    ) : (
                      <span className="badge bg-danger">● Inactive</span>
                    )}
                  </td>

                  <td>
                    <div className="d-flex gap-3">
                      <Eye
                        size={18}
                        style={{ cursor: "pointer" }}
                        onClick={() => handleViewClick(company)}
                      />

                 
                       <FaEdit
    style={{
      cursor: "pointer",
      color: "#666d75", // light gray
      fontSize: "14px",
    }}
    onClick={() => setShowModal(true)}
  />

  <RiDeleteBin6Line
    style={{
      cursor: "pointer",
      color: "#666d75", // even lighter gray
      fontSize: "14px",
    }}
    onClick={() => handleDeleteClick(company)}
  />

                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Card.Body>
{/* 
      <Card.Footer className="bg-white border-top d-flex justify-content-between align-items-center px-3 py-3">
        <div className="d-flex align-items-center gap-2">
          <span style={{ fontSize: "14px", color: "#374151", fontWeight: 500 }}>
            Row Per Page
          </span>
          <Dropdown>
            <Dropdown.Toggle
              variant="light"
              className="shadow-sm border"
              style={{ minWidth: "60px", height: "36px", fontSize: "14px" }}
            >
              {rowsPerPage}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => setRowsPerPage(5)}>5</Dropdown.Item>
              <Dropdown.Item onClick={() => setRowsPerPage(10)}>
                10
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setRowsPerPage(15)}>
                15
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setRowsPerPage(20)}>
                20
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setRowsPerPage(50)}>
                50
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <span
            style={{ fontSize: "13px", color: "#6b7280", marginLeft: "8px" }}
          >
            Entries
          </span>
        </div>

        <div style={{ width: "250px" }}>
          <Form.Control
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{
              borderRadius: "6px",
              border: "1px solid #d1d5db",
              padding: "8px 12px",
              fontSize: "14px",
            }}
          />
        </div>
      </Card.Footer> */}

      <style>{`

      .companies-list{
    border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;
box-shadow:2px 0px 5px rgba(0,0,0,0.05);
      }

      .card-flex{
        display:flex;
        justify-content:space-between;
        align-items:center;
      }

      .icon{
        width:40px;
        height:40px;
        border-radius:8px;
        display:flex;
        align-items:center;
        justify-content:center;
        color:white;
      }

      .primary{background:#ff6b2c;}
      .success{background:#28a745;}
      .danger{background:#dc3545;}
      .info{background:#17a2b8;}

      .label{
        font-size:13px;
        margin-bottom:2px;
        color:#777;
      }

      .export-btn{
        background:#fff;
        border:1px solid #ddd;
        color:"#070707"
      }

      .add-btn{
        background:#ff6b2c;
        border:none;
      }

      .upload-box{
        background:#f5f6f8;
        padding:15px;
        border-radius:10px;
      }

      .upload-img{
        width:60px;
        height:60px;
        border-radius:50%;
        object-fit:cover;
      }

      .upload-btn{
        background:#ff6b2c;
        border:none;
      }

      .modal-dialog{
        max-width:850px;
      }

      .modal-body{
        padding:20px;
        font-size:14px;
      }

      @media(max-width:768px){

        .card-flex{
          flex-direction:column;
          align-items:flex-start;
        }

        .upload-box{
          flex-direction:column;
          align-items:flex-start;
        }

      }

      `}</style>
      {/* VIEW MODAL */}
      <Dialog
        open={showView}
        onClose={() => setShowView(false)}
        maxWidth="sm"
        fullWidth
        sx={{ "& .MuiDialog-paper": { borderRadius: 2 } }}
      >
        <DialogTitle
          sx={{
            fontWeight: 700,
            fontSize: "18px",
            color: "#111827",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #e5e7eb",
            px: 3,
            py: 2,
          }}
        >
          Company Detail
          <IconButton
            aria-label="close"
            onClick={() => setShowView(false)}
            sx={{ color: "#6b7280" }}
          >
            ✕
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ px: 3, py: 3 }}>
          {selectedCompanydata && (
            <Box>
              {/* Header - exact match: avatar + name + email + Active badge */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  bgcolor: "#f8fafc",
                  p: 2.5,
                  borderRadius: 2,
                  mb: 3,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 2.5 }}>
                  <Avatar
                    src={selectedCompanydata?.img || "/fallback.png"} // nee purple icon lanti fallback
                    sx={{ width: 56, height: 56, bgcolor: "#7c3aed" }}
                  />
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: 600, fontSize: "17px" }}
                    >
                      {selectedCompanydata?.name || "BrightWave Innovations"}
                    </Typography>
                    <Typography
                      sx={{ color: "#6b7280", fontSize: "14px", mt: 0.5 }}
                    >
                      {selectedCompanydata?.email || "[email protected]"}
                    </Typography>
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    bgcolor: "#10b981",
                    color: "white",
                    px: 3,
                    py: 0.75,
                    borderRadius: 999,
                    fontSize: "13px",
                    fontWeight: 600,
                  }}
                >
                  ● Active
                </Box>
              </Box>

              {/* Basic Info */}
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: "15px",
                  color: "#111827",
                  mb: 2,
                }}
              >
                Basic Info
              </Typography>

              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={4}>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "13px",
                      color: "#6b7280",
                      mb: 0.5,
                    }}
                  >
                    Account URL
                  </Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                    {selectedCompanydata.url || "bwi.example.com"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "13px",
                      color: "#6b7280",
                      mb: 0.5,
                    }}
                  >
                    Phone Number
                  </Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                    {selectedCompanydata.phoneNumber || "(163) 2459 315"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "13px",
                      color: "#6b7280",
                      mb: 0.5,
                    }}
                  >
                    Website
                  </Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                    {selectedCompanydata.website || "www.example.com"}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "13px",
                      color: "#6b7280",
                      mb: 0.5,
                    }}
                  >
                    Currency
                  </Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                    {selectedCompanydata.currency ||
                      "United States Dollar (USD)"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "13px",
                      color: "#6b7280",
                      mb: 0.5,
                    }}
                  >
                    Language
                  </Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                    {selectedCompanydata.language || "English"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "13px",
                      color: "#6b7280",
                      mb: 0.5,
                    }}
                  >
                    Address
                  </Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                    {selectedCompanydata.address ||
                      "3705 Lynn Avenue, Phelps, WI 54554"}
                  </Typography>
                </Grid>
              </Grid>

              <Box sx={{ borderBottom: "1px solid #e5e7eb", my: 3 }} />

              {/* Plan Details */}
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: "15px",
                  color: "#111827",
                  mb: 2,
                }}
              >
                Plan Details
              </Typography>

              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={4}>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "13px",
                      color: "#6b7280",
                      mb: 0.5,
                    }}
                  >
                    Plan Name
                  </Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                    {selectedCompanydata.planName || "Advanced"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "13px",
                      color: "#6b7280",
                      mb: 0.5,
                    }}
                  >
                    Plan Type
                  </Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                    {selectedCompanydata.planType || "Monthly"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "13px",
                      color: "#6b7280",
                      mb: 0.5,
                    }}
                  >
                    Price
                  </Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                    ${selectedCompanydata.price || "200"}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "13px",
                      color: "#6b7280",
                      mb: 0.5,
                    }}
                  >
                    Register Date
                  </Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                    {selectedCompanydata.registerDate || "12 Sep 2024"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "13px",
                      color: "#6b7280",
                      mb: 0.5,
                    }}
                  >
                    Expiring On
                  </Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                    {selectedCompanydata.expiringOn || "11 Oct 2024"}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #e5e7eb" }}>
          <Button
            onClick={() => setShowView(false)}
            variant="outlined"
            sx={{
              textTransform: "none",
              borderColor: "#d1d5db",
              color: "#374151",
              fontWeight: 500,
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* EDIT MODAL */}

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Company</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* Upload */}

          <div className="upload-box d-flex align-items-center mb-3">
            <img
              src={image || "/assets/img/default-avatar.png"}
              alt=""
              className="upload-img"
            />

            <div className="ms-3">
              <h6 className="mb-1">Upload Profile Image</h6>

              <small className="text-muted">Image should be below 4 mb</small>

              <div className="mt-2">
                <Button
                  size="sm"
                  className="upload-btn me-2"
                  onClick={handleUploadClick}
                >
                  Upload
                </Button>

                <Button size="sm" variant="light">
                  Cancel
                </Button>
              </div>

              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleImageChange}
              />
            </div>
          </div>

          {/* FORM */}

          <Row>
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Name *</Form.Label>
                <Form.Control />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Email Address</Form.Label>
                <Form.Control />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Account URL</Form.Label>
                <Form.Control />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Phone Number *</Form.Label>
                <Form.Control />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Website</Form.Label>
                <Form.Control />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Password *</Form.Label>
                <Form.Control type="password" />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Confirm Password *</Form.Label>
                <Form.Control type="password" />
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group className="mb-2">
                <Form.Label>Address</Form.Label>
                <Form.Control />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Plan Name *</Form.Label>
                <Form.Select>
                  <option>Select</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Plan Type *</Form.Label>
                <Form.Select>
                  <option>Select</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-2">
                <Form.Label>Currency *</Form.Label>
                <Form.Select>
                  <option>Select</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-2">
                <Form.Label>Language *</Form.Label>
                <Form.Select>
                  <option>Select</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-2">
                <Form.Label>Status</Form.Label>
                <Form.Select>
                  <option>Select</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="light">Cancel</Button>

          <Button className="add-btn">Add Company</Button>
        </Modal.Footer>
      </Modal>

      {/* DELETE CONFIRMATION MODAL */}
      <Dialog
        open={showDelete}
        onClose={() => setShowDelete(false)}
        maxWidth="xs"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: 2,
            p: 0,
            overflow: "hidden",
          },
        }}
      >
        <DialogContent
          sx={{
            textAlign: "center",
            pt: 5,
            pb: 4,
            px: 4,
          }}
        >
          {/* Trash Icon - big, centered, red-orange */}
          <Box sx={{ mb: 3 }}>
            <Box
              component="div"
              sx={{
                width: 80,
                height: 80,
                borderRadius: "50%",
                backgroundColor: "#fee2e2", // light red bg like warning
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mx: "auto",
              }}
            >
              <Trash
                size={48}
                color="#ef4444" // bright red for trash (or keep #f96332 if preferred)
              />
            </Box>
          </Box>

          {/* Title */}
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              fontSize: "20px",
              color: "#111827",
              mb: 1.5,
            }}
          >
            Confirm Delete
          </Typography>

          {/* Message - exact phrasing from image, bold "cannot be undone" */}
          <Typography
            sx={{
              color: "#4b5563",
              fontSize: "15px",
              lineHeight: 1.5,
              mb: 4,
            }}
          >
            You want to delete all the marked items, this cant be
            <br />
            undone once you delete.
          </Typography>

          {/* If you want to show specific item/company name conditionally */}
          {/* Uncomment if needed: */}
          {/* {selectedCompany && (
      <Typography sx={{ fontWeight: 500, color: "#ef4444", mb: 3 }}>
        ({selectedCompany.name})
      </Typography>
    )} */}
        </DialogContent>

        <DialogActions
          sx={{
            px: 4,
            pb: 4,
            justifyContent: "center",
            gap: 2,
            borderTop: "1px solid #e5e7eb",
            pt: 3,
          }}
        >
          <Button
            style={{
              textTransform: "none",
              borderColor: "#d1d5db",
              color: "#374151",
              fontWeight: 500,
              minWidth: 110,
              px: 4,
            }}
            onClick={() => setShowDelete(false)}
            variant="outlined"
            // sx={{
            //   textTransform: "none",
            //   borderColor: "#d1d5db",
            //   color: "#374151",
            //   fontWeight: 500,
            //   minWidth: 110,
            //   px: 4,
            // }}
          >
            Cancel
          </Button>

          <Button
            style={{
              textTransform: "none",
              color: "white",
              backgroundColor: "#ef4444", // standard danger red (or #f96332)
              "&:hover": { backgroundColor: "#dc2626" },
              fontWeight: 600,
              minWidth: 140,
              px: 5,
            }}
            onClick={handleConfirmDelete}
            variant="contained"
            // sx={{
            //   textTransform: "none",
            //   backgroundColor: "#ef4444", // standard danger red (or #f96332)
            //   "&:hover": { backgroundColor: "#dc2626" },
            //   fontWeight: 600,
            //   minWidth: 140,
            //   px: 5,
            // }}
          >
            Yes, Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};

export default CompaniesList;
